import { FeatureCollection } from "geojson";
import React from "react";
import { GeocoderControl, Map, MapDrawer, NavigationControl } from "../Mapbox";
import MouseOverlay from "../Mapbox/components/MapDisplay/MouseOverlay";

const mapboxToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

const MAP_OPTIONS_DEFAULT = {
  center: [77.66, 23.53] as [number, number],
  zoom: 3,
  style: "mapbox://styles/mapbox/streets-v11",
};

interface DrawMapProps {
  accessToken?: string;
  center?: [number, number];
  zoom?: number;
  mapStyle?: string;
  drawControls: {
    point?: boolean;
    line_string?: boolean;
    polygon?: boolean;
    trash?: boolean;
  };
  value: FeatureCollection | null;
  setValue: React.Dispatch<FeatureCollection | null>;
  navigation?: boolean;
  geocoder?: boolean;
  latLongOverlay?: boolean;
}

const DrawMap: React.FC<DrawMapProps> = ({
  accessToken = mapboxToken || "",
  center,
  zoom,
  mapStyle,
  drawControls,
  value,
  setValue,
  navigation = true,
  geocoder = true,
  latLongOverlay = true,
}) => {
  const handleGeocoderResult = (result: any) => {
    if (result && result.result && result.result.center) {
      const [lng, lat] = result.result.center;
      const featureCollection: FeatureCollection = {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [lng, lat]
          },
          properties: {}
        }]
      };
      setValue(featureCollection);
    }
  };
  return (
    <div className="w-full h-full">
      <Map
        accessToken={accessToken}
        options={{
          center: center || MAP_OPTIONS_DEFAULT.center,
          zoom: zoom || MAP_OPTIONS_DEFAULT.zoom,
          style: mapStyle || MAP_OPTIONS_DEFAULT.style,
          maxZoom: 18,
        }}
      >
        {geocoder && (
          <GeocoderControl position="top-right" options={{ marker: false, onResult: handleGeocoderResult }} />
        )}
        {navigation && <NavigationControl position="bottom-left" />}
        <MapDrawer
          position="top-left"
          options={{
            displayControlsDefault: false,
            controls: { ...drawControls },
          }}
          value={value}
          setValue={setValue}
        />
        {latLongOverlay && <MouseOverlay position="bottom-right" />}
      </Map>
    </div>
  );
};

export default DrawMap;
